import React, { useState,useContext } from 'react';
import {
  Layout,
  Dropdown,
  Menu,
  Typography,
  Space,
  Drawer,
  Form,
  Input,
  Button,
  message,
} from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LockOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios'; // ✅ adjust path if needed
import { AuthContext } from '../../context/AuthContext';

const { Header } = Layout;
const { Text } = Typography;

const TopHeader = ({ collapsed, toggleCollapsed }) => {
  const navigate = useNavigate();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { user } = useContext(AuthContext);
  const userId = user?.id;
    const username = user?.username || 'User' ;

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      localStorage.clear();
      navigate('/login');
    }

    if (key === 'changePassword') {
      setDrawerOpen(true);
    }
  };

  const handleChangePassword = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      message.error('New passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await api.put(`/api/users/${userId}`, {
        oldPassword,
        newPassword,
      });

      message.success('Password changed successfully. Please login again.');
      setDrawerOpen(false);
      form.resetFields();
      localStorage.clear();
      navigate('/login');
    } catch (error) {
      message.error(
        error?.response?.data?.message || 'Failed to change password'
      );
    } finally {
      setLoading(false);
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="changePassword" icon={<SettingOutlined />}>
        Change Password
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
     <Header
  style={{
    background: '#fff',
    padding: '0 16px',
    display: 'flex',
    justifyContent: 'space-between', // ← pushes ends apart
    alignItems: 'center',
    minHeight: 64,
  }}
>
  {/* Left side: collapse button if exists */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
    {toggleCollapsed && (
      collapsed ? (
        <MenuUnfoldOutlined
          onClick={toggleCollapsed}
          style={{ fontSize: 20, cursor: 'pointer' }}
        />
      ) : (
        <MenuFoldOutlined
          onClick={toggleCollapsed}
          style={{ fontSize: 20, cursor: 'pointer' }}
        />
      )
    )}
  </div>

  {/* Right side: user dropdown */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
    <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          gap: 8,
        }}
      >
        <UserOutlined style={{ fontSize: 18 }} />
        <Text ellipsis style={{ maxWidth: 120 }}>
          {username}
        </Text>
      </div>
    </Dropdown>
  </div>
</Header>


      {/* 🔐 Change Password Drawer */}
      <Drawer
        title="Change Password"
        placement="right"
        width={360}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleChangePassword}
        >
          <Form.Item
            label="Old Password"
            name="oldPassword"
            rules={[{ required: true, message: 'Please enter old password' }]}
          >
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: 'Please enter new password' },
              { min: 6, message: 'Minimum 6 characters' },
            ]}
          >
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>

          <Form.Item
            label="Retype New Password"
            name="confirmPassword"
            rules={[{ required: true, message: 'Please confirm password' }]}
          >
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>

          <Space style={{ width: '100%' }}>
            <Button onClick={() => setDrawerOpen(false)}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Update Password
            </Button>
          </Space>
        </Form>
      </Drawer>
    </>
  );
};

export default TopHeader;
